var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { metadataDefaultsMapGenerator } from './defaults';
import _ from 'lodash';
var booleanMetadataGenerator = function (truthyLabel, falsyLabel, truthyColor, falsyColor) {
    if (truthyLabel === void 0) { truthyLabel = 'Yes'; }
    if (falsyLabel === void 0) { falsyLabel = 'No'; }
    if (truthyColor === void 0) { truthyColor = '#009900'; }
    if (falsyColor === void 0) { falsyColor = '#990000'; }
    return {
        format: {
            truthy: {
                label: truthyLabel,
                color: truthyColor,
            },
            falsy: {
                label: falsyLabel,
                color: falsyColor,
            },
        }
    };
};
/**
 * Renders the received value depending on the metadata set by the user
 *
 * @param {any} t The translate function
 * @param {any} v The actual value of the leaf
 * @param {FieldMetadata} metadata OPTIONAL - metadata of the current field
 * @param {string[]} context OPTIONAL - context to check if value is in the ignore array
 * @param {any} data OPTIONAL - data of the hole row
 * @param {number} indentLevel Number representing depth within an object or array
 * @param {MetadataTypes} type type of the metadata
 *
 * @return {JSX.Element | string} renderValue the actual object created
 */
export function renderValue(t, v, metadata, context, data, indentLevel, type, path, field) {
    if (indentLevel === void 0) { indentLevel = 0; }
    if (path === void 0) { path = ''; }
    var entity = data.entity;
    var dictionary = {};
    if (context && context.dictionary) {
        dictionary = __assign(__assign({}, context.dictionary[entity]), context.dictionary['*']);
    }
    if (metadata && metadata.callback) {
        return metadata.callback(v, data, field);
    }
    if (v === undefined || v === null) {
        return React.createElement("span", { style: { color: '#999999' } }, (metadata && metadata.ifNull) || '');
    }
    var TYPE = (metadata === null || metadata === void 0 ? void 0 : metadata.type) || getType(v);
    switch (TYPE) {
        case 'BOOL':
            var FIXED_BOOL = fixBooleanValues(v);
            if (metadata && metadata.default) {
                metadata = metadataDefaultsMapGenerator(booleanMetadataGenerator, [metadata.default]);
            }
            if (!metadata || !metadata.format || typeof metadata.format !== 'object') {
                return v ? 'true' : 'false';
            }
            return React.createElement("span", { style: { color: FIXED_BOOL ? metadata.format.truthy.color : metadata.format.falsy.color } }, FIXED_BOOL ? metadata.format.truthy.label : metadata.format.falsy.label);
        case 'STR':
            var FIRST_VALUES = v.substring(0, 2);
            if (FIRST_VALUES === '- ' || FIRST_VALUES === '+ ') {
                return (React.createElement("span", { style: { color: FIRST_VALUES === '- ' ? '#990000' : '#009900' } }, v.split('\n').map(function (s, i) { return (React.createElement("div", { key: i },
                    t(s),
                    React.createElement("br", null))); })));
            }
            if (v === '...') {
                return React.createElement("span", { style: { color: '#999999' } }, v);
            }
            return v;
        case 'ARRAY':
            return (React.createElement(React.Fragment, null, v.map(function (v, i) {
                return React.createElement("div", { key: "changes-array-" + i, style: { paddingLeft: indentLevel > 1 ? indentLevel * 8 : 0 } }, renderValue(t, v, metadata, context, data, 1, undefined, path + "." + i, field));
            })));
        case 'OBJ':
            return (React.createElement(React.Fragment, null, Object.keys(v).map(function (key, i) {
                var _a;
                if (!((_a = context === null || context === void 0 ? void 0 : context.ignore) === null || _a === void 0 ? void 0 : _a.includes(key))) {
                    return (React.createElement("div", { style: { paddingLeft: indentLevel > 0 ? indentLevel * 8 : 0 }, key: "changes-object-prop-" + i },
                        renderKey(t, indentLevel, key, entity, dictionary, path),
                        ' ',
                        renderValue(t, v[key], getMetadata(key, metadata), context, data, indentLevel + 1, undefined, path ? path + "." + key : "" + key, field)));
                }
            })));
        case 'template':
            var REGX = /\{(.*?)\}/g; // All words between curly braces { }
            var value = metadata && metadata.format && typeof metadata.format === 'string' ? metadata.format.replace(REGX, function (matched, original) {
                return v[original] || v;
            }) : v;
            return (React.createElement("div", null, value));
        default:
            return v;
    }
}
/**
 * Small utils
 */
var getMetadata = function (key, metadata) {
    if (!metadata) {
        return null;
    }
    if (metadata[key]) {
        return metadata[key];
    }
    return metadata['*'] || metadata;
};
export var isBoolean = function (v) {
    return (typeof v == 'boolean') || v === 'false' || v === 'true';
};
export var fixBooleanValues = function (e) {
    if (!e || e === ' ' || e === 'false')
        return false;
    return (e === true || e === 'true');
};
export var getType = function (v) {
    if (Array.isArray(v)) {
        return 'ARRAY';
    }
    if (isBoolean(v)) {
        return 'BOOL';
    }
    if (typeof v === 'string') {
        return 'STR';
    }
    if (typeof v === 'object') {
        return 'OBJ';
    }
    return 'INT';
};
export function renderKey(t, indentLevel, key, entity, dictionary, path) {
    var FINAL_PATH = path ? path + "." + key : key;
    var translation = null;
    if (dictionary) {
        translation = _.get(dictionary, FINAL_PATH, null);
        if (!translation) {
            translation = _.get(dictionary, key, null);
        }
    }
    return (React.createElement("span", { style: { fontWeight: 'bold' } },
        translation || t(key),
        ":"));
}
export function getTranslatedValue(t, dictionary, v) {
    if (dictionary) {
        return;
    }
    return t(v);
}
//# sourceMappingURL=utils.js.map